// Styles
import { headerHeight } from '../../scripts/helpers';
import './page-legal.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initPageLegal = (context) => {
  const pageLegalSection = context.closest('.shopify-section');
  if (!pageLegalSection) return;

  const mobileMenuContainer = pageLegalSection.querySelector('.legal-area__menu');
  const desktopMenuContainer = pageLegalSection.querySelector('.legal-area__menu__desktop');
  if (!mobileMenuContainer || !desktopMenuContainer) return;

  mobileMenuContainer.style.top = headerHeight();
  desktopMenuContainer.style.top = headerHeight();

  ['resize', 'orientationchange'].forEach(evt => {
    window.addEventListener(evt, function () {
      mobileMenuContainer.style.top = headerHeight();
      desktopMenuContainer.style.top = headerHeight();
    });
  });

  const requestType = pageLegalSection.querySelector('#ContactRequestType')
  const message = pageLegalSection.querySelector('#ContactMessage')

  /**
   * If requestType value is empty or "other", then make these fields required:
   * - #ContactMessage
   */
  makeTargetFieldsRequire(($(requestType).val() == '' || $(requestType).val() == 'other'), [message])
  // Do also on requestType change
  $(requestType).change(function () {
    let condition = ($(requestType).val() == '' || $(requestType).val() == 'other')
    makeTargetFieldsRequire(condition, [message])
    if (condition) {
      $(message).parsley().validate(true)
    }
    else {
      $(message).parsley().reset()
    }
  });

  const productTitle = new URLSearchParams(window.location.search).get('title')?.replace(/ /g, "-");

  if (productTitle) {
    const requestTypePdp = $(requestType).data('requestTypePdp') ?? null

    fetch(window.Shopify.routes.root + 'products/' + productTitle + '.js')
    .then(response => response.json())
      .then(product => {

        const contactProductField = pageLegalSection.querySelector('#ContactProduct-field');
        const contactProduct = pageLegalSection.querySelector('#ContactProduct');

        $(contactProductField).show()
        contactProduct.value = product.title
        $(contactProduct).attr('readonly', true)

        if (requestTypePdp && requestTypePdp != "empty") {
          requestType.value = requestTypePdp
        }
      }
    );
  }
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.legal-area__content'), (el) => {
    window.dAgency.initPageLegal(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.legal-area__content'), (el) => {
      window.dAgency.initPageLegal(el);
    });
  });
}

/**
 * Make target fields required based on a condition
 *
 * @param {boolean} required - Condition to check if target fields must be required
 * @param {Array.<HTMLElement>} targets - Target fields to make required
 */
function makeTargetFieldsRequire(required, targets) {
  targets.forEach(function (target, index) {
    if (required) {
      $(target).siblings('label').find('span').show()
      $(target).attr('data-parsley-required', true)
    }
    else {
      $(target).siblings('label').find('span').hide()
      $(target).attr('data-parsley-required', false)
    }
  })
}
